/*
 *
 *  * Copyright(c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Pipe, PipeTransform } from '@angular/core';
import { DiConfigService } from '@app/di/di-config.service';
import { UtilService } from '@app/util/util.service';
import { AppConfigService } from '@app/common/app-config.service';
import { IntegrationStatusService } from '@app/di/integration-status.service';
import { ContextService } from '@app/di/context.service';

@Pipe({
  name: 'tabs'
})
export class TabsPipe implements PipeTransform {
  private isSupportMoreTabs;

  constructor(
    private diConfigService: DiConfigService,
    private utilService: UtilService,
    private appConfigService: AppConfigService,
    private integrationStatusService: IntegrationStatusService,
    private contextService: ContextService
  ) {}

  transform(value: any, inputType: string): any {
    let pipeResult: any = undefined;
    this.isSupportMoreTabs = this.appConfigService.getAppConfigByKey('unlimitedTabs') === 'true';
    switch (inputType) {
      case 'tabsOverflow': {
        pipeResult = this.isSupportMoreTabs && value >= 5;
        break;
      }
      case 'isViewerLaunched': {
        const tab = this.utilService.getActiveTab();
        pipeResult = !(
          tab &&
          (this.integrationStatusService.isViewerPending() || this.contextService.isViewerOpened(tab.id))
        );
        break;
      }
    }
    return pipeResult;
  }
}
